<template>
  <v-dialog persistent width="450" v-model="dialogOpen">
    <v-card>
      <v-card-title>Current Provider</v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-select v-model="current_provider" label="Provider" placeholder="Select an option" :items="getLeadProviders" :disabled="formLoading" hide-details outlined dense required></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-menu ref="dateMenu" v-model="dateMenu" :close-on-content-click="false" :return-value.sync="current_contract_end_date" transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="current_contract_end_date" label="Contact end date" placeholder="YYYY-MM-DD" :disabled="formLoading" readonly hide-details outlined dense required v-bind="attrs" v-on="on"></v-text-field>
              </template>

              <v-date-picker v-model="current_contract_end_date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.dateMenu.save(current_contract_end_date)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field v-model="current_monthly_price" label="Monthly price" placeholder="£" type="number" :disabled="formLoading" hide-details outlined dense required></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field v-model="current_speed_mbps" label="Speed (Mbps)" placeholder="Type here..." type="number" :disabled="formLoading" hide-details outlined dense required></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small :disabled="formLoading" :loading="formLoading" @click="save">Save</v-btn>
        <v-btn color="primary" outlined small @click="close">cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    props: {
      dialogOpen: {
        type: Boolean,
        default: false,
      }
    },

    data() {
      return {
        current_provider: '',
        current_contract_end_date: '',
        current_monthly_price: '',
        current_speed_mbps: '',
        formLoading: false,
        dateMenu: false,
      }
    },

    computed: {
      ...mapGetters('leads', ['getCurrentLead', 'getCurrentLeadLoading', 'getLeadProviders']),
    },

    watch: {
      dialogOpen(val) {
        if(val){
          this.current_provider = this.getCurrentLead.current_provider;
          this.current_contract_end_date = this.getCurrentLead.current_contract_end_date;
          this.current_monthly_price = this.getCurrentLead.current_monthly_price;
          this.current_speed_mbps = this.getCurrentLead.current_speed_mbps;
        }
      }
    },

    methods: {
      ...mapActions('leads', ['updateCurrentProvider']),

      close() {
        this.$emit('close-dialog');
      },

      async save() {
        this.formLoading = true;

        try {
          await this.updateCurrentProvider({
            id: this.getCurrentLead.id,
            data: {
              current_provider: this.current_provider,
              current_contract_end_date: this.current_contract_end_date,
              current_monthly_price: this.current_monthly_price,
              current_speed_mbps: this.current_speed_mbps,
            }
          });

          this.formLoading = false;
          this.close();
        } catch(error) {
          this.formLoading = false;
        }
      },
    },
  }
</script>

<style lang="scss" scoped></style>
